module.exports = __webpack_public_path__ + "img/16-7.f7d7721d.jpg";